





































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, maskDate } from '@/utils/common'
import { SolicitacaoElegivelParaCirurgiaConjunta, AgendamentoParaGerenciarCirurgiaConjunta } from '@/types/interfaces/CirurgiaConjunta'

@Component
export default class ComponentBackofficeGerenciarCirurgiaConjunta extends Vue {
  @Prop({ required: true }) agendamento: AgendamentoParaGerenciarCirurgiaConjunta

  searchText: string = ''

  solicitacoes: SolicitacaoElegivelParaCirurgiaConjunta[] = []

  loadingBusca: boolean = false

  loadingAssociarId: string | null = null

  loadingDesassociarId: string | null = null

  tableHeaders = [
    { text: 'Médico', value: 'medicoNome', sortable: false },
    { text: 'Paciente', value: 'nomePaciente', sortable: false },
    { text: 'Procedimento', value: 'procedimentoPrincipal', sortable: false },
    { text: 'Data', value: 'data', sortable: false },
    { text: '', value: 'acoes', sortable: false },
  ]

  get solicitacoesFiltradas() {
    const termo = this.searchText.trim().toLowerCase()

    if (!termo) {
      return this.solicitacoes
    }

    return this.solicitacoes.filter(item => [item.medicoNome, item.nomePaciente, item.procedimentoPrincipal]
      .some(campo => (campo || '').toLowerCase().includes(termo)))
  }

  mounted() {
    this.buscarSolicitacoesElegiveis()
  }

  formatDate(data: string) {
    return maskDate(data)
  }

  ehSolicitacaoPrincipal(solicitacao: SolicitacaoElegivelParaCirurgiaConjunta) {
    return solicitacao.solicitacaoId === this.agendamento.id
  }

  visualizarSolicitacao(solicitacao: SolicitacaoElegivelParaCirurgiaConjunta) {
    if (!solicitacao.solicitacaoId) {
      return
    }

    const { href } = this.$router.resolve({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId: solicitacao.solicitacaoId } })
    window.open(href, '_blank')
  }

  async buscarSolicitacoesElegiveis() {
    this.loadingBusca = true

    const response = await Apis.Agendamento.CirurgiaConjuntaApi.getSolicitacoesElegiveis({
      SolicitacaoId: this.agendamento.id,
    })

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar solicitações elegíveis.', 'error'))
      this.loadingBusca = false
      return
    }

    this.solicitacoes = response.data || []
    this.loadingBusca = false
  }

  async associar(solicitacao: SolicitacaoElegivelParaCirurgiaConjunta) {
    this.loadingAssociarId = solicitacao.solicitacaoId

    const response = await Apis.Agendamento.CirurgiaConjuntaApi.associar(this.agendamento.hospitalId, {
      solicitacaoBaseId: this.agendamento.id,
      solicitacaoParaAssociarId: solicitacao.solicitacaoId,
    })

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao associar a cirurgia conjunta.', 'error'))
      this.loadingAssociarId = null
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage('Solicitação associada com sucesso!', 'success'))
    await this.buscarSolicitacoesElegiveis()
    this.$emit('atualizado')
    this.loadingAssociarId = null
  }

  async desassociar(solicitacao: SolicitacaoElegivelParaCirurgiaConjunta) {
    this.loadingDesassociarId = solicitacao.solicitacaoId

    const response = await Apis.Agendamento.CirurgiaConjuntaApi.desassociar(this.agendamento.hospitalId, solicitacao.id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao desassociar a cirurgia conjunta.', 'error'))
      this.loadingDesassociarId = null
      return
    }

    EventBus.$emit('setSnackbar', getSnackbarMessage('Solicitação desassociada com sucesso!', 'success'))
    await this.buscarSolicitacoesElegiveis()
    this.$emit('atualizado')
    this.loadingDesassociarId = null
  }
}
